__turbopack_context__.v({
  "ant-input-number": "editor-drawer-module__zu47Ba__ant-input-number",
  "ant-slider": "editor-drawer-module__zu47Ba__ant-slider",
  "ant-slider-handle": "editor-drawer-module__zu47Ba__ant-slider-handle",
  "ant-slider-rail": "editor-drawer-module__zu47Ba__ant-slider-rail",
  "ant-slider-track": "editor-drawer-module__zu47Ba__ant-slider-track",
  "ant-space": "editor-drawer-module__zu47Ba__ant-space",
  "ant-switch": "editor-drawer-module__zu47Ba__ant-switch",
  "ant-switch-checked": "editor-drawer-module__zu47Ba__ant-switch-checked",
  "ant-tabs-content-holder": "editor-drawer-module__zu47Ba__ant-tabs-content-holder",
  "ant-tabs-ink-bar": "editor-drawer-module__zu47Ba__ant-tabs-ink-bar",
  "ant-tabs-tab": "editor-drawer-module__zu47Ba__ant-tabs-tab",
  "ant-tabs-tab-active": "editor-drawer-module__zu47Ba__ant-tabs-tab-active",
  "ant-tabs-tabpane": "editor-drawer-module__zu47Ba__ant-tabs-tabpane",
  "ant-typography": "editor-drawer-module__zu47Ba__ant-typography",
  "darkTheme": "editor-drawer-module__zu47Ba__darkTheme",
  "editorDrawer": "editor-drawer-module__zu47Ba__editorDrawer",
});
